import { useParams } from 'react-router-dom';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchReportById } from 'api/reports';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';

const useCurrentReport = () => {
    const { accountId } = useCurrentAccount();
    const { report_id } = useParams<{ report_id: string }>();
    const reportId = Number(report_id);

    return useSuspenseQuery({
        queryKey: accountQueryKeys.reportById(accountId, reportId),
        queryFn: () => fetchReportById(accountId, reportId),
        retry: false,
    });
};

export { useCurrentReport };
